// [PATCH izdaja-potrditev-fe v1] Prodaja -> Nastavitve -> Ostalo: popravljanje izdanega računa do »Potrdi«
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Pencil, Loader } from 'lucide-react';
import { api } from '../../lib/api';

export function PopravljanjeRacunaKartica({ companyId }: { companyId?: string | null }) {
  const [vklop, setVklop] = useState<boolean | null>(null);
  const [shranjujem, setShranjujem] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    api.get(`/izdaja/${companyId}/nastavitve`)
      .then(r => setVklop(r.data?.nastavitve?.popravljanje_racuna !== false))
      .catch(() => setVklop(null));
  }, [companyId]);

  const preklopi = async () => {
    if (!companyId || vklop === null) return;
    setShranjujem(true);
    try {
      const r = await api.put(`/izdaja/${companyId}/nastavitve`, { popravljanje_racuna: !vklop });
      setVklop(r.data?.nastavitve?.popravljanje_racuna !== false);
      toast.success('Nastavitev shranjena.');
    } catch (e: any) {
      const det = e?.response?.data?.detail;
      toast.error(typeof det === 'string' ? det : 'Shranjevanje ni uspelo.');
    } finally { setShranjujem(false); }
  };

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400">
          <Pencil className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Popravljanje računa</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">Izdan račun gre v računovodstvo šele, ko klikneš Potrdi</p>
        </div>
      </div>
      {vklop === null ? (
        <div className="flex items-center justify-center h-12"><Loader className="w-5 h-5 text-blue-500 animate-spin" /></div>
      ) : (
        <>
          <label className="flex items-center gap-3 cursor-pointer select-none">
            <input type="checkbox" className="w-4 h-4" checked={vklop} disabled={shranjujem} onChange={preklopi} />
            <span className="text-sm text-gray-800 dark:text-gray-200">Omogoči popravljanje izdanega računa do potrditve</span>
          </label>
          <ul className="mt-3 text-xs text-gray-500 dark:text-gray-400 list-disc pl-5 space-y-1">
            <li>Izdan račun ostane <b>nepotrjen</b>: popraviš ga lahko, dokler ga ne pošlješ kupcu (številka ostane ista).</li>
            <li>V računovodsko obravnavo (in DDV evidenco) gre šele po kliku <b>Potrdi</b> ali <b>Potrdi vse</b>.</li>
            <li>Dokler so računi nepotrjeni, vsak dan prejmeš opomnik na e-pošto — računovodstvo brez njih ne more zaključiti obdobja.</li>
            <li>Velja za račun, avansni račun in dobropis. Pošiljanje kupcu dokument samodejno potrdi.</li>
            <li>Izklopljeno: izdan dokument gre takoj v računovodstvo (kot doslej). Storno in račun s poračunom avansa gresta vedno takoj; nepotrjen avans ni na voljo za poračun.</li>{/* [PATCH izdaja-potrditev v2] */}
          </ul>
        </>
      )}
    </div>
  );
}
